var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 45 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_28354)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_278_28354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6837 22.5356C38.6837 33.4145 29.7647 46.1283 22.7654 46.1283C15.7661 46.1283 6.83789 33.4145 6.83789 22.5356C6.83789 11.6567 13.9658 5.86328 22.7562 5.86328C31.5467 5.86328 38.6745 11.666 38.6745 22.5356H38.6837Z",
    fill: "#00A7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1837 22.5356V21.0356H40.1306C39.8287 15.9637 37.9884 11.9062 35.0591 9.04945C31.8566 5.9264 27.4807 4.36328 22.7562 4.36328C18.0324 4.36328 13.6563 5.92368 10.4536 9.04574C7.24051 12.1779 5.33789 16.7554 5.33789 22.5356C5.33789 28.3456 7.7044 34.5339 10.9392 39.2589C12.563 41.6308 14.4439 43.6912 16.4256 45.1731C18.3908 46.6425 20.5724 47.6283 22.7654 47.6283C24.9585 47.6283 27.1396 46.6425 29.104 45.1729C31.0849 43.6909 32.9646 41.6305 34.5873 39.2585C37.8198 34.5334 40.1837 28.3452 40.1837 22.5356Z",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7556 28.3477C27.5394 28.3477 31.4174 24.4153 31.4174 19.5645C31.4174 14.7136 27.5394 10.7812 22.7556 10.7812C17.9718 10.7812 14.0938 14.7136 14.0938 19.5645C14.0938 24.4153 17.9718 28.3477 22.7556 28.3477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_278_28354",
    x: 0.837891,
    y: 0.863281,
    width: 43.8457,
    height: 52.2656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0345139 0 0 0 0 0.0398071 0 0 0 0 0.0583333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_278_28354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_278_28354",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_28354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestIcon);
export default __webpack_public_path__ + "static/media/destIcon.3dd32e10fd143c0c64fe80ceee487ceb.svg";
export { ForwardRef as ReactComponent };